/** @desc 营销增长 */
import api from '@/api';

const state = {
  loading: false,
  efoCateBuyBtnWrap: {},
  popData: {}, // 客户端弹窗数据
};

const mutations = {
  setCommonPopData(state, data) {
    state.popData = data;
  },
  setEfoCateBuyBtnWrap(state, data) {
    let { index, clear, btn, title } = data
    if (clear) {
      state.efoCateBuyBtnWrap = {}
      return
    }
    let {btnList = [], titleList = []} = state.efoCateBuyBtnWrap
    btn && btnList.push(index)
    title && titleList.push(index)
    state.efoCateBuyBtnWrap = {
      btnList,
      titleList
    }
  },
};

const actions = {
  /** @desc 获取客户端弹窗信息 */
  async getActPopFun({ commit, state }, param) {
    state.loading = true;
    try {
      const res = await api.apiGetCommonPopup(param);
      commit('setCommonPopData', res);
    } catch {}
    state.loading = false;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
